/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/auth/actionsTypes';
import * as ConfigTypeActions from '../store/config/actionsTypes';
import BaseService from '../services/BaseService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';
import * as ModuleConfigurationActions from '../store/moduleConfiguration/actionsTypes';

import { CLEAR_DASHBOARD } from '../store/dashboard/actionsTypes';
import { CLEAR_USER } from '../store/usuario/actionsTypes';
import { NSIRS_CLEAN } from '../store/nsir/actionsTypes';
import { FILTRO_CLEAN } from '../store/filtro/actionsTypes';
import { getEstados, getCidades } from '../utils';

function* completeAuthSession(response, callback) {
  yield put({
    type: TypeActions.FETCH_AUTH_SUCCESS,
    data: response.data,
  });

  yield put({ type: ModuleConfigurationActions.FETCH_MODULE_CONFIGURATION });

  const estados = yield getEstados();
  yield put({
    type: ConfigTypeActions.UPDATE_ESTADOS,
    data: estados,
  });

  const cidades = yield getCidades();
  yield put({
    type: ConfigTypeActions.UPDATE_CIDADES,
    data: cidades,
  });

  yield put({ type: FILTRO_CLEAN });
  yield put({ type: NSIRS_CLEAN });
  yield put({ type: LoaderTypeActions.LOADER_HIDE });
  callback(response.data.updatePassword, true);
}

function* login({ authData, callback, options = {} }) {
  const suppressErrorToast = options.suppressErrorToast === true;

  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'login', data: authData, useToken: false });
    yield completeAuthSession(response, callback);
  } catch (error) {
    console.log(error)
    let message = 'Erro ao logar';
    if (error.response && error.response.status && error.response.status === 401) {
      message = 'Usuário e senha inválidos!';
    } else if (error.response && error.response.status && error.response.status === 403) {
      message = 'O usuário bloqueado temporariamente. Por favor, contacte o administrador do sistema!'
    }
    if (!suppressErrorToast) {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message
      });
    }
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    callback(null, false, message);
  }
}

function* loginMicrosoft({ callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    // TODO: habilitar quando o backend expuser POST login/microsoft
    // const response = yield BaseService.post({
    //   url: 'login/microsoft',
    //   data: { idToken: microsoftAuth.idToken },
    //   useToken: false,
    // });
    // yield completeAuthSession(response, callback);

    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Login Microsoft ainda não está disponível. Aguarde a integração com o backend.',
    });
    callback(null, false);
  } catch (error) {
    console.log(error);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao autenticar com Microsoft',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    callback(null, false);
  }
}

function * forgotPassword({ forgotData }) {
  try {
    yield console.log('forgotPassword');
    // const response = yield AuthService.forgotPassword(forgotData);
    // yield put({
    //     type: TypeActions.FETCH_AUTH_SUCCESS,
    //     data: response.data
    // });
  } catch (error) {
    // yield put({
    //     type: TypeActions.FETCH_AUTH_FAILED,
    //     error
    // });
  }
}

function * updatePassword({ id, data, callback, showMessage = false }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.post({ url: `usuarios/${id}/reset/password`, data });
    yield callback();

    if (showMessage) {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
        message: 'Senha atualizada com sucesso!'
      });
    }

    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);

    let message = 'Erro ao atualizar a senha';
    if (error.response && error.response.status && error.response.status === 409) {
      message = error.response.data.mensagem;
    }

    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message
    });

    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  }
}

function* updateProfile({ data }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.post({ url: 'usuarios/profile', data });
    yield put({
      type: TypeActions.UPDATE_PROFILE_SUCCESS,
      data
    });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
  }
}

function * logout({ history }) {
  yield put({ type: TypeActions.AUTH_CLEAR });
  yield put({ type: CLEAR_DASHBOARD });
  yield put({ type: CLEAR_USER });

  history.push('/login');
}

export default function * watchAuth() {
  yield takeLatest(TypeActions.FETCH_AUTH, login);
  yield takeLatest(TypeActions.FETCH_AUTH_MICROSOFT, loginMicrosoft);
  yield takeLatest(TypeActions.FETCH_FORGOT_PASSWORD, forgotPassword);
  yield takeLatest(TypeActions.UPDATE_PASSWORD, updatePassword);
  yield takeLatest(TypeActions.UPDATE_PROFILE, updateProfile);
  yield takeLatest(TypeActions.AUTH_LOGOUT, logout);
}